import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import { navigationPropsShape } from 'AppSrc/core/components/forms/section-nav';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  RELATIONSHIPS,
  SECTION_TITLES,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  MOBILE,
  RISK_LEVEL_1,
  RISK_LEVEL_2,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  getRiskValue,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
// form fields
import { relationshipsField } from './relationships-modal/relationships-field';
import { impactedLocation } from './relationships-modal/impacted-location';



// Section ID (for the data layer)
const sectionId = RELATIONSHIPS;
// Title for the main form
const sectionTitle = SECTION_TITLES[sectionId];


// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = (params) => {

  const {
    formData,
  } = params;

  const riskValue = MOBILE ? getRiskValue(formData) : null;

  const IsRiskLevel = (riskValue === RISK_LEVEL_1 || riskValue === RISK_LEVEL_2);

  const currentFields = [];
  currentFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...impactedLocation,
      vFParams: {
        ...impactedLocation.vFParams,
        fieldTitle: `Impacted Location ${IsRiskLevel ? '(optional)' : ''}`,
      },
      validator: IsRiskLevel ? () => null : impactedLocation.validator,
    },
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: relationshipsField,
  });
  return currentFields;
};

// generates the formSection!
const Relationships = React.memo(({
  handleSuccessfulSubmit,
  userRoles,
  formData,
  navigationProps,
  sectionIndex,
  editingStatus,
}) => {
  // Props for the SectionNav in FormSection. these come from the parent but we mutate them to be relivent to the section
  const filteredNavigationProps = {
    ...navigationProps,
    submitForm: null,
  };

  const formattedSectionTitle = prefixStringWithIndexPlusOne(sectionTitle, sectionIndex);

  return (
    <FormSection
      sectionTitle={formattedSectionTitle}
      sectionId={sectionId}
      getCurrentFields={getCurrentFields}
      userRoles={userRoles}
      formData={formData}
      navigationProps={filteredNavigationProps}
      handleSuccessfulSubmit={handleSuccessfulSubmit}
      editingStatus={editingStatus}
    />
  );
});



Relationships.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  userRoles: userRolesPropShape,
  formData: formDataShape,
  navigationProps: navigationPropsShape,
  sectionIndex: PropTypes.number,
  editingStatus: PropTypes.string,
};

export {
  Relationships,
  getCurrentFields,
  RELATIONSHIPS,
};
